import {FiX} from "react-icons/fi";

import {Chip} from "@/components/chip/Chip.tsx";
import {IconButton} from "@/components/iconButton/IconButton.tsx";
import {PhoneNumber} from "@/components/phone/PhoneNumber.tsx";

interface ListInputItemsListProps {
  items: string[];
  remove: (idx: number) => void;
  phoneNumber?: boolean;
}

export const ListInputItemsList = ({items, remove, phoneNumber = false}: ListInputItemsListProps) => {
  return (
    items.length > 0 && (
      <div className="mt-2 d-flex flex-column gap-1">
        {items.map((item: string, idx: number) => (
          <div key={`list-input-${idx}`}>
            <Chip variant="tag">
              {phoneNumber ? <PhoneNumber value={item} /> : item}
              <IconButton icon={FiX} variant="ghost" size="fitIcon" onClick={() => remove(idx)} />
            </Chip>
          </div>
        ))}
      </div>
    )
  );
};
